import { forwardRef } from 'react';

import { Thumbnail } from '../../primitives/thumbnail';
import { cn } from '../../utils/cn';
import { InputField } from './input-field';

type ThumbnailProps = React.ComponentPropsWithoutRef<typeof Thumbnail>;

interface InputMediaProps extends React.ComponentPropsWithoutRef<typeof InputField> {
  thumbnailSize?: ThumbnailProps['size'];
}

const InputMedia = forwardRef<HTMLInputElement, InputMediaProps>(
  ({ thumbnailSize = 'sm', ...props }, ref) => {
    const { value, disabled, isLoading } = props;

    let type: 'video' | 'image' | 'document' = 'document';
    if (String(value).includes('/cms/image/')) {
      type = 'image';
    } else if (String(value).includes('/cms/video/')) {
      type = 'video';
    }

    return (
      <div
        className={cn('flex items-center gap-4', {
          'cursor-not-allowed': disabled || isLoading,
        })}
      >
        <Thumbnail className="flex-none" size={thumbnailSize} src={value} type={type} />
        <InputField ref={ref} {...props} />
      </div>
    );
  },
);

InputMedia.displayName = 'InputMedia';

export { InputMedia };
